import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7099ff28"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "evse-status tag" }
const _hoisted_2 = {
  key: 0,
  class: "status-detail"
}
const _hoisted_3 = { class: "evse-status-list" }
const _hoisted_4 = { class: "text-status" }
const _hoisted_5 = { class: "evse-name" }
const _hoisted_6 = { class: "extra-content" }

import { computed } from 'vue'
import { EvseState } from '@/types/types'
import useI18nTl from '@/hooks/useI18nTl'

import { defineComponent } from 'vue'

const __default__ = defineComponent({
  name: 'EvseStatus',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  state: {
    type: Number,
  },

  tags: {
    type: [],
    defuault: () => [],
  },
},
  setup(__props) {

const props = __props

const { t, tl } = useI18nTl('Evses')



const evseTags = computed(() => {
  return props.tags || []
})

const statusLabel = computed(() => {
  switch (props.state) {
    case EvseState.ES_OFFLINE:
      return tl('stateOffline')
    case EvseState.ES_ONLINE:
      return tl('stateOnline')
    case EvseState.ES_EXCEPTION:
      return tl('stateException')
  }
  return tl('stateNonactivated')
})

const statusClass = computed(() => {
  switch (props.state) {
    case EvseState.ES_OFFLINE:
      return 'info'
    case EvseState.ES_ONLINE:
      return 'success'
    case EvseState.ES_EXCEPTION:
      return 'danger'
  }
  return 'warning'
})

return (_ctx: any,_cache: any) => {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_openBlock(), _createBlock(_component_el_tooltip, {
    placement: "right",
    "popper-class": "tooltip-evse-status-list"
  }, {
    content: _withCtx(() => [
      (_unref(evseTags).length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("ul", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(evseTags), (tag, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  class: "evse-status-item",
                  key: index
                }, [
                  _createElementVNode("span", _hoisted_4, _toDisplayString(tag), 1),
                  _createElementVNode("span", _hoisted_5, _toDisplayString(tag), 1)
                ]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_6, [
        _renderSlot(_ctx.$slots, "extra-content")
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, [
        _createElementVNode("span", {
          class: _normalizeClass(["text-status", _unref(statusClass)])
        }, _toDisplayString(_unref(statusLabel)), 3)
      ])
    ]),
    _: 3
  }))
}
}

})